import React from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes
} from "react-router-dom";
import AboutUs from "./AboutUsPage/AboutUsPage";
import BlogsCardDetails from "./BlogsCardPage/BlogsPage";
import BlogDetailsPage from "./BlogsCardPage/ReadBlog/BlogDetailsPage";
import CareerDetailsPage from "./CareersPage/CareerDetailPage/CareerDetailsPage";
import Careers from "./CareersPage/CareersPage";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Home from "./HomePage/HomePage";
import Login from "./Login/Login";
import MobileMaintainance from "./MaintainancePages/MobileMaintainance";
import SuccessRegistration from "./MaintainancePages/RegistrationSuccess";
import UnderMaintainance from "./MaintainancePages/UnderMaintainance";
import ProfilePage from "./ProfilePages/GaneshProfilePage/ProfilePage";
import ProfileHeader from "./ProfilePages/ProfileHeader/ProfileHeader";
import CourseProgramDetailsPage from "./ProgramsPage/CourseDetails/CourseProgramDetailsPage";
import Programs from "./ProgramsPage/ProgramsPage";
import Register from "./Register/Register";
import Services from "./ServicesPage/ServicesPage";


export default function LandingPage(props) {
  const profile = true;

  return (
    <div>
      <Router>
      {profile ? (
        <div>
        <Header />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/home" exact element={<Home />} />
          <Route path="/services" exact element={<Services />} />
          <Route path="/programs" exact element={<Programs />} />
          <Route path="/programs/:courseCode/" exact  element={<CourseProgramDetailsPage />} />
          <Route path="/about-us" exact element={<AboutUs />} />
          <Route path="/careers" exact element={<Careers />} />
          <Route path="/careers-details" exact element={<CareerDetailsPage />} />
          <Route path="/blogs" exact element={<BlogsCardDetails />} />
          <Route path="/blogs/:id" exact element={<BlogDetailsPage />} />
          <Route path="/register" element={<Register />} />
          <Route  path="/login" exact element={<Login />}/>
          <Route path="/undermaintainance" element={<UnderMaintainance />} />
          <Route path="/success-registration" element={<SuccessRegistration />} />
          <Route path="/mobile-maintainance" element={<MobileMaintainance />} />
          <Route path="*" element={<Navigate to="/" replace />} />    
        </Routes>
        <Footer />
        </div>
        )
        :
        <div>   
          <ProfileHeader/>
          <Routes>
            <Route path="/" exact element={<ProfilePage />} />
            <Route path="/blogs" exact element={<BlogsCardDetails />} />
        </Routes>
          {/* <ProfileFooter /> */}
                 
      </div>}
    </Router>   
      
      
    </div>
  );
}
